import { useOffline } from "../lib/offline";
import { WifiHigh, WifiSlash, CloudArrowUp } from "@phosphor-icons/react";
import { toast } from "sonner";

export const OfflineIndicator = () => {
  const { online, pending, sync } = useOffline();

  const doSync = async () => {
    const n = await sync();
    if (n > 0) toast.success(`Synced ${n} queued item${n > 1 ? "s" : ""}`);
  };

  return (
    <div className="flex items-center gap-2">
      {pending > 0 && (
        <button data-testid="pending-sync-button" onClick={doSync}
          className="h-11 px-4 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-xs font-bold flex items-center gap-2 tap-press hover:bg-amber-100">
          <CloudArrowUp size={18} weight="duotone" className="pulse-dot" /> {pending} pending sync
        </button>
      )}
      <div data-testid="connection-indicator"
        className={`h-11 px-4 rounded-full border text-xs font-bold flex items-center gap-2 ${
          online ? "bg-white border-slate-200 text-slate-500" : "bg-red-50 border-red-200 text-red-700"}`}>
        {online ? <WifiHigh size={18} className="text-emerald-500" /> : <WifiSlash size={18} className="pulse-dot" />}
        {online ? "Online" : "Offline — cached mode"}
      </div>
    </div>
  );
};
